import {useState, useEffect, memo, useMemo} from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TableContainer from "@mui/material/TableContainer";
import { BarChart, XAxis, YAxis, Legend, Bar, Tooltip, Cell } from "recharts";
import LegendContent from "./LegendContent";
import ModalDialog from "./ModalDialog";
import { getFormatedTime } from "../../../tools";
import useStyles from "./useStyles";
import { dataPresentationPalette } from "../../../shared/constants/dataPresentationPalette";

const TimeDiagram = (props) => {
  const classes = useStyles();
  const { widgetType, widgetLabel, dataArr, widgetLegend } = props;
  const [visibleDialog, setVisibleDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [eventType, setEventType] = useState(undefined);
  const handleClick = (item) => {
    if (widgetType === "timeDiagram") {
      setDialogTitle(item?.label);
      setEventType(item?.rowName);
      setVisibleDialog(true);
    }
  };

  const [paletteHeigh, setPaletteHeight] = useState(window.innerWidth);
  const [paletteWidth, setPaletteWidth] = useState(window.innerWidth);

  const handleResize = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 1830) {
      setPaletteWidth(600);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 1681) {
      setPaletteWidth(500);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 1401) {
      setPaletteWidth(400);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 1221) {
      setPaletteWidth(300);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 1181) {
      setPaletteWidth(800);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 1081) {
      setPaletteWidth(700);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 981) {
      setPaletteWidth(600);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 881) {
      setPaletteWidth(500);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 791) {
      setPaletteWidth(400);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 541) {
      setPaletteWidth(300);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 481) {
      setPaletteWidth(250);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 401) {
      setPaletteWidth(380);
      setPaletteHeight(276.5);
    } else if (screenWidth >= 361) {
      setPaletteWidth(340);
      setPaletteHeight(276.5);
    }
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const colorsForDashboards = useMemo(() => {
    switch (widgetLegend) {
      case "Всего":
        return dataPresentationPalette[3]
      case "Время активности прибора":
        return dataPresentationPalette[4]
      case "Движение":
        return dataPresentationPalette[5]
      case "В том числе на транспорте":
        return dataPresentationPalette[6]
      case "В том числе пешком":
        return dataPresentationPalette[7]
      case "Активность без передвижения":
        return dataPresentationPalette[8]
      case "Чистый простой":
        return dataPresentationPalette[9]
      case "Обеденный перерыв":
        return dataPresentationPalette[10]
      default:
        return dataPresentationPalette[3]
    }
  }, [widgetLegend])

  const isMonoColor = useMemo(() => {
    return widgetType !== "timeDiagram"
  }, [widgetType])

  return (
    <>
      {visibleDialog ? (
        <ModalDialog
          title={dialogTitle}
          eventType={eventType}
          onClose={() => setVisibleDialog(false)}
        />
      ) : null}
      <div className={classes.containerTimeDiagram}>
        <Typography className={classes.title}>{widgetLegend}</Typography>
        <TableContainer
          className={classes.containerTable}
          component={Paper}
          style={{ boxShadow: "none", overflow: "hidden" }}
        >
          <div className={classes.containerBarChartAndLegend}>
            <div className={classes.containreBarChart}>
              <BarChart
                width={paletteWidth}
                height={paletteHeigh}
                className={classes.barChart}
                data={dataArr}
                margin={{ top: 1, right: 0, left: -17, bottom: 0 }}
              >
                {widgetType === "timeDiagram" ? null : (
                  <XAxis dataKey="label" fontSize={12} />
                )}
                <YAxis
                  width={94}
                  className={classes.yaxis}
                  tickFormatter={(time) => getFormatedTime(time)}
                  domain={[0, "dataMax"]}
                  fontSize={12}
                />
                <Tooltip
                  cursor={{ fill: "#F6F6F6" }}
                  formatter={(time) => getFormatedTime(time)}
                  labelFormatter={(defLabel, parsableLabel) =>
                    parsableLabel?.[0]?.payload?.label || defLabel
                  }
                  className={classes.tooltip}
                />
                <Bar
                  name="Время"
                  dataKey="rawValue"
                  fill="#000"
                  //onClick={handleClick}
                  maxBarSize={35}
                >

                  { isMonoColor ? (
                    // для оптимизации выносим проверку на палитру цветов до отрисовки всех данных по графику !!!
                    dataArr.map(({ id }) => (
                      <Cell key={`cell-${id}`} fill={colorsForDashboards} />
                    ))
                  ) : (
                      dataArr.map(({ id }) => (
                        <Cell key={`cell-${id}`} fill={dataPresentationPalette[id] || "#8884d8"} />
                      ))
                  )}

                </Bar>
              </BarChart>
            </div>
            {widgetType === "timeDiagram" ? (
              <div className={classes.information}>
                <Legend
                  className={classes.legendContent}
                  content={LegendContent}
                  payload={dataArr.map(({ label, color, id }) => ({
                    value: label,
                    type: "rect",
                    color: dataPresentationPalette[id],
                  }))}
                />
              </div>
            ) : null }
          </div>
        </TableContainer>
      </div>
    </>
  );
};
export default memo(TimeDiagram);
